module.exports = __webpack_public_path__ + "static/img/visual_sub_title.fba83b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/images/visual_sub_title.png
// module id = toJJ
// module chunks = 0